interface IRoutes {
  sidepanel: string;
  signup: string;
  login: string;
  forgotpassword: string;
  mapRanking: string;
  localSEOHeatmap: string;
  ctrBooster: string;
  reportBuilder: string;
  reportBuilderConnect: string;
  mapCheckins: string;
  scheduleACall: string;
  manageLocalBusiness: string;
  resetpassword: string;
  resetEmployeepassword: string;
  authSuccess: string;
  authAppleSuccess: string;
  businessImportSuccess: string;
  businessFetchSuccess: string;
  dashboard: string;
  map: string;
  admin: string;
  adminLogin: string;
  adminDashboard: string;
  adminUsers: string;
  adminBusiness: string;
  adminScans: string;
  adminCTRBooster: string;
  adminMapCheckCIns: string;
  upgrade: string;
  billing: string;
  reselling: string;
  payment: string;
  paymentIncomplete: string;
  history: string;
  mapSEO: string;
  publicReport: string;
  publicReportBuilder: string;
  publicReviewRequest: string;
  guestCheckerReport: string;
  adminConfiguration: string;
  adminPlanSetting: string;
  adminAddonPlan: string;
  creditPayment: string;
  creditPaymentIncomplete: string;
  localSEOHeatmapManager: string;
  managerMap: string;
  adminManager: string;
  rankingChecker: string;
  ctrBoosterForm: string;
  mapCheckingDashboard: string;
  mapCheckingSetting: string;
  mapCheckingCalender: string;
  mapCheckingReviews: string;
  mapCheckingWidget: string;
  mapchekcingteam: string;
  addEmployee: string;
  businessdashboard: string;
  verfiyEmployee: string;
  addMapCheckIn: string;
  adminGBPBusiness: string;
  download: string;
  adminTransferAccount: string;
  compareBusinessLocation: string;
  adminCompareBusinessLocation: string;
  whitelabel: string;
  facebookSuccess: string;
  instagramSuccess: string;
  instagramFBSuccess: string;
  youtubeSuccess: string;
  tiktokSuccess: string;
  googleBusinessReconnectSuccess: string;
  acceptTransfer: string;
  acceptInvite: string;
  workspaceMember: string;
  adminAudioSetting: string;
  adminCrmImport: string;
  maprankingPrivacyPolicy: string;
  maprankingTermsAndConditions: string;
  onboarding: string;
  onboardingStep: string;
  onboardingConnectGoogle: string;
  onboardingConnectSocials: string;
  onboardingInviteTeam: string;
  onboardingInstallWidget: string;
}

export const routes: IRoutes = {
  sidepanel: "/sidepanel",
  signup: "/signup",
  login: "/login",
  forgotpassword: "/forgot-password",
  mapRanking: "/MapRanking",
  localSEOHeatmap: "/LocalSEOHeatmap",
  manageLocalBusiness: "/ManageLocalBusiness",
  resetpassword: "/reset-password",
  resetEmployeepassword: "/employee-reset-password",
  dashboard: "/dashboard",
  authSuccess: "/auth/success",
  authAppleSuccess: "/auth/apple/success",
  businessImportSuccess: "/business/import/success",
  businessFetchSuccess: "/business/fetch/success",
  map: "/map",
  admin: "/admin",
  adminLogin: "/admin/login",
  adminDashboard: "/admin/dashboard",
  adminUsers: "/admin/users",
  adminBusiness: "/admin/business",
  adminScans: "/admin/scans",
  adminTransferAccount: "/admin/transfer-account",
  adminCTRBooster: "/admin/ctr-booster",
  adminMapCheckCIns: "admin/map-checkins",
  upgrade: "/upgrade",
  billing: "/billing",
  reselling: "/reselling",
  payment: "/payment",
  paymentIncomplete: "/payment-incomplete",
  history: "/history",
  mapSEO: "/map-seo",
  publicReport: "/public-report",
  publicReportBuilder: "/public-report-builder",
  publicReviewRequest: "/public/review-request",
  guestCheckerReport: "/guest-checker-report",
  adminConfiguration: "/admin/configuration",
  adminPlanSetting: "/admin/plan",
  adminAddonPlan: "/admin/edit-addon",
  creditPayment: "/credit-payment",
  creditPaymentIncomplete: "/credit-payment-incomplete",
  localSEOHeatmapManager: "/admin/manager-localSEOHeatmap",
  managerMap: "/admin/manager-map",
  adminManager: "/admin/manager",
  rankingChecker: "/ranking-checker",
  ctrBooster: "/ctr-booster",
  reportBuilder: "/report-builder",
  reportBuilderConnect: "/report-builder/connect/:platform/:reportId/:businessId/:accountId?",
  mapCheckins: "/map-checkins",
  scheduleACall: "/schedule-call",
  ctrBoosterForm: "/ctr-booster-form",
  mapCheckingDashboard: "/mapcheckins-dashboard",
  mapCheckingSetting: "/mapcheckins-setting",
  mapCheckingCalender: "/mapcheckins-calendar",
  mapCheckingReviews: "/mapcheckins-reviews",
  mapCheckingWidget: "/mapcheckins-widget",
  mapchekcingteam: "/mapcheckins-team",
  addEmployee: "/employee",
  businessdashboard: "/businessdashboard",
  verfiyEmployee: "/verify-employee",
  addMapCheckIn: "/add-map-check-in",
  adminGBPBusiness: "/admin/gbp-business",
  download: "/download",
  compareBusinessLocation: "/compare-business-location",
  adminCompareBusinessLocation: "/admin/compare-business-location",
  whitelabel: "/white-label",
  facebookSuccess: "/business/integrations/facebook/success",
  instagramSuccess: "/business/integrations/instagram/success",
  instagramFBSuccess: "/business/integrations/instagram-portfolio/success",
  youtubeSuccess: "/business/integrations/youtube/success",
  tiktokSuccess: "/business/integrations/tiktok/success",
  googleBusinessReconnectSuccess: `/business/${localStorage.getItem("selecetd")}/reconnect/success`,
  acceptTransfer: "/accept-transfer",
  acceptInvite: "/accept-invite",
  workspaceMember: "/workspace-member",
  adminAudioSetting: "/admin/audio-setting",
  adminCrmImport: "/admin/crm-import",
  maprankingPrivacyPolicy: "/privacy-policy",
  maprankingTermsAndConditions: "/terms-and-conditions",
  onboarding: "/onboarding",
  onboardingStep: "/onboarding/:step",
  onboardingConnectGoogle: "/onboarding/connect-google",
  onboardingConnectSocials: "/onboarding/connect-socials",
  onboardingInviteTeam: "/onboarding/invite-team",
  onboardingInstallWidget: "/onboarding/install-widget",
};
